export default {
  initial: 'INBOX',
  // prettier-ignore
  COMPOSE: { // eslint-disable-line sort-keys
      back: 'INBOX',
      sent: 'SENT'
    },
  INBOX: {
    compose: 'COMPOSE',
    select: 'VIEW',
    selectSent: 'SENT'
  },
  REPLY: {
    back: 'INBOX',
    sent: 'SENT'
  },
  SENT: {
    back: 'INBOX'
  },
  VIEW: {
    back: 'INBOX',
    reply: 'REPLY'
  }
};
